import { ChevronLeft, ChevronRight } from "lucide-mui";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../utils/format.ts";

interface PaginationControlsProps {
  rowsPerPage: number;
  pageItemCount: number;
  total: number;
  cursorStackDepth: number;
  hasPrev: boolean;
  hasNext: boolean;
  onChangeRowsPerPage: (n: number) => void;
  onPrev: () => void;
  onNext: () => void;
}

export default function PaginationControls({
  rowsPerPage,
  pageItemCount,
  total,
  cursorStackDepth,
  hasPrev,
  hasNext,
  onChangeRowsPerPage,
  onPrev,
  onNext,
}: PaginationControlsProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 2,
        px: 2,
        py: 1,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        Rows per page:
      </Typography>
      <Select
        size="small"
        variant="standard"
        value={rowsPerPage}
        onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}
      >
        {[25, 50, 100].map((n) => (
          <MenuItem key={n} value={n}>
            {n}
          </MenuItem>
        ))}
      </Select>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {`${cursorStackDepth * rowsPerPage + 1}–${
          cursorStackDepth * rowsPerPage + pageItemCount
        } of ${formatNumber(total)}`}
      </Typography>
      <IconButton
        size="small"
        aria-label="Previous page"
        disabled={!hasPrev}
        onClick={onPrev}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        aria-label="Next page"
        disabled={!hasNext}
        onClick={onNext}
      >
        <ChevronRight fontSize="small" />
      </IconButton>
    </Box>
  );
}
